/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import PropTypes from "prop-types";
import * as R from "ramda";

const AutoComplete = ({ placeHolder, suggestions, value, onValueChanged }) => {
  const [inputValue, setInputValue] = useState(value);
  const [waitTime, setWaitTime] = useState(0);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  let filteredSuggestions = suggestions
    .filter(x => x)
    .filter(x => x && inputValue && x.toLowerCase().includes(inputValue.toLowerCase()));
  filteredSuggestions = R.dropRepeatsWith((a, b) => a === b, filteredSuggestions);
  const doSearch = e => {
    const { value } = e.target;
    setInputValue(value);
    setShowSuggestions(true);
    if (waitTime) clearTimeout(waitTime);
    setWaitTime(
      setTimeout(() => {
        onValueChanged(value);
      }, 300)
    );
  };
  const onKeyDown = e => {
    // User pressed the enter key, update the input and close the
    // suggestions
    if (e.keyCode === 13) {
      const selectedValue = filteredSuggestions[activeSuggestion];
      setActiveSuggestion(0);
      setShowSuggestions(false);
      setInputValue(selectedValue);
      onValueChanged(selectedValue);
    }
    // User pressed the up arrow, decrement the index
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      setActiveSuggestion(activeSuggestion - 1);
    }
    // User pressed the down arrow, increment the index
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }
      setActiveSuggestion(activeSuggestion + 1);
    }
  };
  const onClick = e => {
    const selectedValue = e.currentTarget.innerText;
    setActiveSuggestion(0);
    setShowSuggestions(false);
    setInputValue(selectedValue);
    onValueChanged(selectedValue);
  };

  const SuggestionList =
    showSuggestions && inputValue && filteredSuggestions.length ? (
      <ul className="suggestions">
        {filteredSuggestions.map((suggestion, index) => {
          let className;
          if (index === activeSuggestion) {
            className = "suggestion-active";
          }
          return (
            // Por estilos se decidio usar li
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li className={className} key={`${suggestion}`} onClick={onClick}>
              {suggestion}
            </li>
          );
        })}
      </ul>
    ) : null;

  return (
    <div
      className="col-10"
      onBlur={() => {
        setTimeout(() => setShowSuggestions(false), 300);
      }}
    >
      <input
        onKeyDown={e => onKeyDown(e)}
        value={inputValue}
        onChange={e => doSearch(e)}
        className="form-control search-input"
        type="text"
        placeholder={`\ue99a ${placeHolder}`}
      />
      {SuggestionList}
    </div>
  );
};

AutoComplete.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  onValueChanged: PropTypes.func,
  placeHolder: PropTypes.string
};

AutoComplete.defaultProps = {
  placeHolder: "Buscar ...",
  suggestions: [],
  value: "",
  onValueChanged: () => {}
};

export default AutoComplete;
